import styled from 'styled-components';
import { useRef } from 'react';
import { styled as styledMui } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { ListHypo } from './list-hypo';

export const HypoListModal = (props) => {
  const { open, setOpen, daysAgo } = props;
  const topModalRef = useRef();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomizedDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle className="dialog-container" id="alert-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: { xs: 20, md: 40 },
            top: 10,
            color: '#707070',
            width: '3px',
            background: 'transparent !important'
          }}
        >
          <CloseIcon sx={{ fontSize: { xs: '1rem', md: '2rem' } }} />
        </IconButton>
        <p className="modal-title">Hypoglycemic Events</p>
      </StyledDialogTitle>
      <StyledDialogContent>
        <Grid ref={topModalRef} container className="description-container">
          <Grid item xs={12} display="flex" justifyContent="center" dir="ltr">
            <span className="purple-text">
              Readings {typeof daysAgo == 'number' && 'From'} &nbsp;
            </span>
            <span className="red-text">
              {daysAgo} {typeof daysAgo == 'number' && 'days ago'}
            </span>
          </Grid>
          <Grid item xs={12} mt="7px" dir="ltr">
            <p className="purple-text">
              To view more hypoglycemia readings,
              <br /> please change the report time span.
            </p>
          </Grid>
        </Grid>
        <ListHypo {...props} topModalRef={topModalRef} />
      </StyledDialogContent>
    </CustomizedDialog>
  );
};

const CustomizedDialog = styledMui(Dialog)`
  & .MuiDialog-paper {
    width: 90%;
    max-width: 790px;
    min-height: 350px;
    background: #ebebeb;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 0;
    margin: 0;
  }
  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }
  & .MuiDialogContent-root {
    padding: 0;
    background-color: #ebebeb;
  }
  @media screen and (min-width: 1024px) {
    & .MuiDialog-paper {
      width: 790px;
    }
  }
`;
const StyledDialogTitle = styled(DialogTitle)`
  .dialog-container {
    padding-top: 40px !important;
  }
  .modal-title {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
    color: #d81d5d;
  }
  @media screen and (min-width: 1024px) {
    .modal-title {
      font-size: 28px;
    }
  }
`;
const StyledDialogContent = styled(DialogContent)`
  .purple-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    color: #6f4d9f;
  }
  .description-container {
    background-color: transparent;
    padding-bottom: 37px;
  }
  .red-text {
    font-size: 14px;
    font-family: 'dana-bold';
    line-height: 22px;
    letter-spacing: 0;
    text-align: center;
    color: #d81d5d;
  }

  @media screen and (min-width: 1024px) {
    .purple-text,
    .red-text {
      font-size: 24px;
      line-height: 48px;
    }
  }
`;
